<template>
  <div id="kt_header_mobile" class="kt-header-mobile  kt-header-mobile--fixed " >
    <div class="kt-header-mobile__logo">
      <a href=""  @onClick.prevent="$router.push({ name: 'home' })">
        <img alt="Logo" src="/img/ttc-logo.png" width="50"/>
      </a>
    </div>
  </div>
</template>

<script>
import SidebarMixin from '@/mixins/sidebar'

export default {
  name: 'NavbarMainMobile',
  mixins: [ SidebarMixin ]
}
</script>
